module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/taiguo.95fe4fc9.mp3";